/* eslint-disable */
// Vue
import Vue from 'vue';
import App from './App';

// 配置
import Setting from './setting';
import Setting1 from '@/setting.env';

// 混合
import mixinApp from '@/mixins/app';

// 插件
import plugins from '@/plugins';

// store
import store from '@/store/index';

// 网络请求 by hwf
import axios from 'axios';
import qs from 'qs';
// import VueAxios from 'vue-axios'

// iView 和 iView Pro
import ViewUI from 'view-design';
import iViewPro from '@/libs/iview-pro/iview-pro.min.js';

// 菜单和路由
import router from './router';
import menuHeader from '@/menu/header';
import menuSider from '@/menu/sider';
import { frameInRoutes } from '@/router/routes';

// 多语言
import i18n from '@/i18n';

// 方法
import { getHeaderName, getMenuSider, getSiderSubmenu } from '@/libs/system';

// 内置组件
import iLink from '@/components/link';
// 手机端通用组件套件（m-page / m-table / m-search / m-sheet / m-fab / m-pager / m-toolbar）
import MobileKit from '@/components/mobile';
// 移动端适配：全局 isMobile 等属性
import MobileGlobals from '@/plugins/mobile';
// Element UI 表格手机端卡片化指令 v-mcard
import MobileTableDirective from '@/plugins/mobile-table';

// 使用样式，修改主题可以在 styles 目录下创建新的主题包并修改 iView 默认的 less 变量
// 参考 https://www.iviewui.com/docs/guide/theme
import './styles/index.less';
import './libs/iview-pro/iview-pro.css';
import $ from 'jquery';
import moment from 'moment';
import FullCalendar from 'vue-full-calendar';
import VueClipboard from 'vue-clipboard2';
import echarts from 'echarts';
import util from './libs/util';
import 'echarts/map/js/world.js';
import 'echarts/map/js/china.js';
import 'echarts/extension-src/bmap/bmap.js';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

if (window) window.$t = (key, value) => i18n.t(key, value);
window.$ = $;

axios.interceptors.request.use(
  (config) => {
    const token = util.cookies.get('token');
    const userId = util.cookies.get('userId');
    const role = util.cookies.get('role');
    // 1) GET 请求: config.data 是 undefined,后面的 .indexOf 会 throw → 直接放行
    if (config.data === undefined || config.data === null) {
      return config;
    }
    // 2) legacy API(.NET MVC, URL 包含 /Gemini/) 需要 form-encoded;
    //    Object body 用 qs.stringify 序列化 + 补 userId/token/role
    const url = (config.url || '') + '';
    const isLegacy = url.indexOf('/Gemini/') !== -1;
    if (isLegacy && typeof config.data === 'object' && !(config.data instanceof FormData)) {
      const obj = Object.assign({}, config.data, { userId: userId || '', token: token || '', role: role || '' });
      config.data = qs.stringify(obj);
      config.headers = Object.assign({}, config.headers, { 'Content-Type': 'application/x-www-form-urlencoded' });
      return config;
    }
    // 3) 非 legacy 的 Object body(api2) 接 JSON,放行
    if (config.data instanceof Object) {
      return config;
    }
    // 4) string body: 追加 userId/token/role
    if (config.data.indexOf('userId') === -1) {
      config.data += `&userId=${userId || ''}`;
    }
    if (config.data.indexOf('token') === -1) {
      config.data += `&token=${token || ''}`;
    }
    if (config.data.indexOf('role') === -1) {
      config.data += `&role=${role || ''}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

Vue.prototype.$echarts = echarts;
Vue.prototype.axios = axios;
Vue.prototype.qs = qs;
// Vue.use(VueAxios, axios)

Vue.use(plugins);

Vue.use(ViewUI, {
  i18n: (key, value) => i18n.t(key, value),
});
Vue.use(iViewPro);
Vue.use(FullCalendar);
Vue.use(VueClipboard);
Vue.use(moment);

Vue.component('i-link', iLink);

// 手机端适配：全局属性 + 通用组件 + el-table 卡片化指令
Vue.use(MobileGlobals);
Vue.use(MobileKit);
Vue.use(MobileTableDirective);

new Vue({
  mixins: [mixinApp],
  router,
  store,
  i18n,
  render: (h) => h(App),
  created () {
    // 处理路由 得到每一级的路由设置
    this.$store.commit('admin/page/init', frameInRoutes);
    // 设置顶栏菜单
    this.$store.commit('admin/menu/setHeader', menuHeader);
    // 加载用户登录的数据
    this.$store.dispatch('admin/account/load');
    // 初始化全屏监听
    this.$store.dispatch('admin/layout/listenFullscreen');
  },
  watch: {
    // 监听路由 控制侧边栏显示 标记当前顶栏菜单（如需要）
    $route (to, from) {
      const path = to.path;
      if (!Setting.dynamicSiderMenu) {
        const headerName = getHeaderName(path, menuSider);
        // 在 404 时，是没有 headerName 的
        if (headerName !== null) {
          this.$store.commit('admin/menu/setHeaderName', headerName);

          const filterMenuSider = getMenuSider(menuSider, headerName);
          this.$store.commit('admin/menu/setSider', filterMenuSider);
          this.$store.commit('admin/menu/setActivePath', path);

          const openNames = getSiderSubmenu(path, menuSider);
          this.$store.commit('admin/menu/setOpenNames', openNames);
        }
      }
      this.appRouteChange(to, from);
    },
  },
}).$mount('#app');

// 自动退出登录
var lastTime = new Date().getTime();
var currentTime = new Date().getTime();
var timeOut = 60 * 60 * 1000; // 设置超时时间： 60分
var timeOut1 = 15 * 1000; // 15秒无操作

window.onload = function () {
  window.document.onmousedown = function () {
    localStorage.setItem('lastTime', new Date().getTime());
  };
};
function checkTimeout () {
  currentTime = new Date().getTime(); // 更新当前时间
  lastTime = localStorage.getItem('lastTime');
  // console.log(currentTime - lastTime);
  // console.log(timeOut);
  let diff = currentTime - lastTime;
  if (diff > timeOut) {
    // 判断是否超时
    console.log('长时间无操作,自动退出');
    // store.state.LoginState = 0;
    // store.state.UserId = '';
    // sessionStorage.removeItem('LoginState');
    // sessionStorage.removeItem('UserId');
    // sessionStorage.removeItem('NickName');
    // router.push(`/login`);
  } else if (diff >= timeOut1) {
    //自动更新数据和界面
  }
}
/* 定时器 间隔30秒检测是否长时间未操作页面 */
window.setInterval(checkTimeout, 30000);

// 定时通知
function PlayNotice () {
  // 创建音频上下文
  var audioCtx = new AudioContext();
  // 创建音调控制对象
  var oscillator = audioCtx.createOscillator();
  // 创建音量控制对象
  var gainNode = audioCtx.createGain();
  // 音调音量关联
  oscillator.connect(gainNode);
  // 音量和设备关联
  gainNode.connect(audioCtx.destination);
  // 音调类型指定为正弦波
  oscillator.type = 'sine';
  // 设置音调频率
  oscillator.frequency.value = 196.0;
  // 先把当前音量设为0
  gainNode.gain.setValueAtTime(0, audioCtx.currentTime);
  // 0.01秒时间内音量从刚刚的0变成1，线性变化
  gainNode.gain.linearRampToValueAtTime(1, audioCtx.currentTime + 0.01);
  // 声音走起
  oscillator.start(audioCtx.currentTime);
  // 1秒时间内音量从刚刚的1变成0.001，指数变化
  gainNode.gain.exponentialRampToValueAtTime(0.001, audioCtx.currentTime + 1);
  // 1秒后停止声音
  oscillator.stop(audioCtx.currentTime + 1);
}

function getMessage () {
  axios
    .post(Setting1.BaseUrl1 + '/Order/NoticeList', qs.stringify({}))
    .then(function (response) {
      let res = response.data;
      if (res.Result && res.Count > 0) {
        PlayNotice();
        let url =
          'https://gemini-image.oss-cn-shanghai.aliyuncs.com/mall/mp3/tip.mp3';
        let audio = new Audio(url);
        audio.play();
        //通知完毕告诉后端
        $.ajax({
          url: Setting1.BaseUrl1 + '/Order/UpdateNoticeState',
          type: 'post',
          data: {
            ids: res.Data,
          },
          success: function (res1) {
            if (res1.Result) {
            }
          },
        });
      } else {
        // Message.error(res.Msg)
      }
    })
    .catch(function (error) {
      // Message.error('获取失败')
      console.log(error);
    });
}

/* 定时器 获取通知 */
// window.setInterval(getMessage, 5000)
